import styles from "../resume/Resume.module.scss";

function Resume() {
  return (
    <div className={styles.maincontainer}>
      <div className={styles.imagecontainer}>
        <img
          alt="Resume"
          src="https://github.com/AbdulSamadgithub/AbdulSamadgithub/blob/master/Abdulsamad_Resume_15-07-2022-09-27-20.jpg?raw=true"
          className={styles.image}
        />
      </div>
    </div>
  );
}

export default Resume;
